import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";

const CalendarItem = ({
  name,
  onClick,
  selected,
}: {
  name: string;
  onClick?: () => void;
  selected?: { id: string; name: string };
}) => {
  return (
    <Container onClick={onClick}>
      <UI.Radio selected={name === selected?.name} />
      <UI.Icon name="google" size={24} />
      <UI.Typography
        type="body01 normal"
        fontStyle="medium"
        color="var(--alias-color-label-normal)"
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {name}
      </UI.Typography>
    </Container>
  );
};

export default CalendarItem;

const Container = styled.div`
  display: flex;
  cursor: pointer;

  padding: 16px;
  align-items: center;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;

  border-radius: 10px;
  border: 1px solid var(--alias-color-line-normal);
  background: var(--alias-color-background-normal-normal);

  .info {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1 0 0;
  }
`;
